<template>
    <div class='sub'>
        <MyPageHeader/>
        <div class='container myPage'>
            <ul v-if='fullVUi' class='tabs'>
                <li class='tab' :class='{on:toggleState}'>
                  <!-- 관심상품 -->
                    <a class='link' @click='toggleState = true'>{{$t('MyPage.myMenu')}}</a>
                </li>
                <li class='tab' :class='{on:!toggleState}'>
                  <!-- 주문내역 -->
                    <a class='link' @click='toggleState = false'>{{$t('MyPage.orderHistory')}}</a>
                </li>
            </ul>
            <!-- 관심상품 -->
            <MyMenuContainer v-if='toggleState'/>
            <OrderHistoryContainer v-else/>
        </div>
    </div>
</template>
<script lang="js">
import MyMenuContainer from '@/components/MyPage/MyMenuContainer.vue'
import OrderHistoryContainer from '@/components/MyPage/OrderHistoryContainer.vue'
import MyPageHeader from '@/components/Header/MyPageHeader.vue'
import { MY_PAGE_NAME } from '@/utils/EndPoint'
export default {
  name: MY_PAGE_NAME,
  components: { MyPageHeader, MyMenuContainer, OrderHistoryContainer },
  data () {
    return {
      toggleState: true, // true: 관심상품, false: 주문내역
      fullVUi: ''
    }
  },
  created () {
    const currentURL = window.location.href // 객체 생성
    const params = new URLSearchParams(new URL(currentURL).search) // 파라미터 추출
    if (!this.fullVUi) { // 간편타입의 UI일 경우 주문내역만
      this.toggleState = false
      if (params.get('langType')) {
        this.$i18n.locale = params.get('langType')
      } else if (sessionStorage.getItem('langType')) {
        this.$i18n.locale = sessionStorage.getItem('langType')
      } else {
        this.$i18n.locale = this.$store.getters.langType
      }
    }
  },
  mounted () {
    this.fullVUi = sessionStorage.getItem('fullVUi')
  }
}
</script>
